import { useEffect, useState } from 'react';

const QUERY = '(pointer: coarse)';

const matches = (): boolean =>
  typeof globalThis.matchMedia === 'function' && globalThis.matchMedia(QUERY).matches;

/** True on a touch screen, where nothing can wait for a hover. */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(matches);
  useEffect(() => {
    if (typeof globalThis.matchMedia !== 'function') return undefined;
    const query = globalThis.matchMedia(QUERY);
    const onChange = () => setCoarse(query.matches);
    query.addEventListener?.('change', onChange);
    return () => query.removeEventListener?.('change', onChange);
  }, []);
  return coarse;
}
